module.exports = __webpack_public_path__ + "static/img/no_data.ab9be1e1.png";